module.exports = __webpack_public_path__ + "img/BE.c769032c.svg";